package amazon.lastmile.inject

import app.nestbridge.domain.identity.service.DefaultUserService
import app.nestbridge.domain.identity.service.UserService
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = DefaultUserService::class)
public interface AppNestbridgeDomainIdentityServiceDefaultUserService {
  @Provides
  public fun provideDefaultUserServiceUserService(defaultUserService: DefaultUserService): UserService = defaultUserService
}
